// extracted by mini-css-extract-plugin
export default {"formWrapper":"customer-form_formWrapper__uhuH9","actionBtnWrapper":"customer-form_actionBtnWrapper__IhHyP","nextBtn":"customer-form_nextBtn__uVZWU"};